
export const CREATE_USER_FORM_REPORTS_ALL = 'CREATE_USER_FORM_REPORTS_ALL';